// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TVOi","question":"styles_question__1dwoN","description":"styles_description__3n25F"};